import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { BentoGrid } from "../components/BentoGrid";
import { Catalog } from "../components/Catalog";
import { Footer } from "../components/Footer";
import { ProductModal } from "../components/ProductModal";
import { CartDrawer } from "../components/CartDrawer";
import { CheckoutModal } from "../components/CheckoutModal";

export default function Home() {
  return (
    <div className="overflow-x-clip bg-white font-sans text-slate-900">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <BentoGrid />
        <Catalog />
      </main>
      <Footer />
      <ProductModal />
      <CartDrawer />
      <CheckoutModal />
    </div>
  );
}
